import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import ParametriSettings from "./ParametriSettings";
import StripeSettings from "./StripeSettings";
import GestioneMetodiPagamento from "./GestioneMetodiPagamento";
import ComunicazioniVendorSettings from "./ComunicazioniVendorSettings";
import PermissionsSettings from "./PermissionsSettings";
import { usePermissions } from "../Context/permissionsProvider";
import AdminPageHeader, { adminPageShellSx } from "../Shared/AdminPageHeader";

const Impostazioni = () => {
  const [tab, setTab] = useState(0);
  const { featureFlags } = usePermissions();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  // Tab visibili in base ai feature flag. La lista è dinamica: nascondere un
  // tab qualsiasi (anche non l'ultimo) non rompe gli indici degli altri.
  const visibleTabs = [
    { key: "parametri", label: "Parametri", enabled: featureFlags.enableGestioneParametri, render: () => <ParametriSettings /> },
    { key: "stripe", label: "Configurazione Stripe", enabled: featureFlags.enableConfigurazioneStripe, render: () => <StripeSettings /> },
    { key: "metodi", label: "Metodi di Pagamento", enabled: featureFlags.enableMetodiPagamento, render: () => <GestioneMetodiPagamento /> },
    { key: "comunicazioni", label: "Comunicazioni", enabled: true, render: () => <ComunicazioniVendorSettings /> },
    { key: "permessi", label: "Permessi", enabled: featureFlags.enableGestionePermessi, render: () => <PermissionsSettings /> },
  ].filter((t) => t.enabled);

  // Clamp: se il tab selezionato non esiste più (flag cambiato) ripiega sul primo.
  const activeIndex = tab < visibleTabs.length ? tab : 0;
  const activeTab = visibleTabs[activeIndex];

  return (
    <Box sx={adminPageShellSx}>
      <AdminPageHeader
        title="Impostazioni"
        subtitle="Gestisci i parametri generali e la configurazione della piattaforma."
      />

      {visibleTabs.length > 0 ? (
        <Tabs
          value={activeIndex}
          onChange={handleTabChange}
          sx={{
            mb: 3,
            borderBottom: "1px solid #e2e8f0",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 700,
              fontSize: "1rem",
              color: "#64748b",
            },
            "& .Mui-selected": { color: "#0b3d87 !important" },
            "& .MuiTabs-indicator": { backgroundColor: "#0b3d87", height: 3, borderRadius: "3px" },
          }}
        >
          {visibleTabs.map((t) => (
            <Tab key={t.key} label={t.label} />
          ))}
        </Tabs>
      ) : null}

      {activeTab ? activeTab.render() : null}
    </Box>
  );
};

export default Impostazioni;
